import { OmniaObjectType } from "../omnia"

export function getActivity(create: boolean, { type, id, number: name }: { type: OmniaObjectType, id: number, number: string }) {

    const typeId = getTypeId(type)

    return {
        action: create ? "c" : "u",
        resourceId: create ? undefined : `${typeId}:${id}`,
        resourceType: type,
        data: {
            Name: name
        }
    }

}


function getTypeId(type: OmniaObjectType) {
    switch (type) {
        case OmniaObjectType.SoilAnalysis: return "std"
        case OmniaObjectType.PcnAnalysis: return "pcn"
        case OmniaObjectType.NitrogenAnalysis: return "n"
        case OmniaObjectType.HsAnlaysis: return "hsa"
    }
}
